import { render, staticRenderFns } from "./OsobaDodatnaAktivnostForma.vue?vue&type=template&id=e8ecda84&scoped=true&"
import script from "./OsobaDodatnaAktivnostForma.vue?vue&type=script&lang=js&"
export * from "./OsobaDodatnaAktivnostForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ecda84",
  null
  
)

export default component.exports